<template>
  <!-- Alert for progress is 100% or higher -->
  <div
    v-if='Number(total / currentPort.target) * 100 > 99'
    :class="['msg', 'icon', 'valid']"
  >
    <div class="icon">
      <awesomeIcon icon="check"/>
    </div>
    <div class="alertText">
      <b>Gefeliciteerd, uw doel is bereikt</b><br />
      U blijft belegd binnen het huidige profiel, maar wellicht wilt u uw risico
      verlagen/verhogen of uw looptijd verlengen. Klik op de knop om uw klantprofiel te
      openen en uw looptijd aan te passen. Heeft u vragen of hulp nodig, klik dan op
      'Contact opnemen' in het menu.
    </div>
    <button @click="$parent.redo()" class="alertButton">
      Open klantprofiel
    </button>
  </div>

  <!-- Alert for progress between 95% and 100%, duration higher than 0 and lower than 31 -->
  <div
    v-else-if='
      Math.ceil(daysTillGoal) > 1
      && Math.ceil(daysTillGoal) < 31
      && Number(total / currentPort.target) * 100 > 94
      && Number(total / currentPort.target) * 100 < 100
    '
    :class="['msg', 'icon', 'warning']"
  >
    <div class="icon">
      <awesomeIcon icon="info-circle"/>
    </div>
    <div class="alertText">
      <b>Binnenkort verstrijkt de looptijd en uw doel is bijna behaald</b><br />
      U blijft belegd binnen het huidige profiel, maar wellicht wilt u uw risico
      verlagen/verhogen of uw looptijd verlengen. Klik op de knop om uw klantprofiel te
      openen en uw looptijd aan te passen. Heeft u vragen of hulp nodig, klik dan op
      'Contact opnemen' in het menu.
    </div>
    <button @click="$parent.redo()" class="alertButton">
      Open klantprofiel
    </button>
  </div>

  <!-- Alert for progress between 95% and 100% and duration lower than 1 -->
  <div
    v-else-if='
      Math.ceil(daysTillGoal) < 1
      && Number(total / currentPort.target) * 100 > 94
      && Number(total / currentPort.target) * 100 < 100
    '
    :class="['msg', 'icon', 'warning']"
  >
    <div class="icon">
      <awesomeIcon icon="info-circle"/>
    </div>
    <div class="alertText">
      <b>Uw looptijd is verstreken en u heeft uw doel bijna behaald</b><br />
      U blijft belegd binnen het huidige profiel, maar wellicht wilt u uw risico
      verlagen/verhogen of uw looptijd verlengen. Klik op de knop om uw klantprofiel te
      openen en uw looptijd aan te passen. Heeft u vragen of hulp nodig, klik dan op
      'Contact opnemen' in het menu.
    </div>
    <button @click="$parent.redo()" class="alertButton">
      Open klantprofiel
    </button>
  </div>

  <!-- Alert for progress lower than 95% and duration lower than 31 and higher than 0 -->
  <div
    v-else-if='
      Number(total / currentPort.target) * 100 < 95
      && Math.ceil(daysTillGoal) > 0
      && Math.ceil(daysTillGoal) < 31
    '
    :class="['msg', 'icon', 'warning']"
  >
    <div class="icon">
      <awesomeIcon icon="info-circle"/>
    </div>
    <div class="alertText">
      <b>De looptijd is bijna verstreken en u heeft uw doel nog niet behaald</b><br />
      U blijft belegd binnen het huidige profiel, maar wij adviseren u wanneer mogelijk, uw
      looptijd te verlengen. Mogelijk in combinatie met het eenmalig of periodiek verhogen van
      uw inleg. Klik op de knop om uw klantprofiel te openen en uw looptijd aan te passen.
      Heeft u vragen of hulp nodig, klik dan op 'Contact opnemen' in het menu.
    </div>
    <button @click="$parent.redo()" class="alertButton">
      Open klantprofiel
    </button>
  </div>

  <!-- Alert for progress lower than 95% and duration lower than 1 -->
  <div
    v-else-if='
      Number(total / currentPort.target) * 100 < 95
      && Math.ceil(daysTillGoal) < 1
    '
    :class="['msg', 'icon', 'warning']"
  >
    <div class="icon">
      <awesomeIcon icon="info-circle"/>
    </div>
    <div class="alertText">
      <b>De looptijd is verstreken en u heeft uw doel nog niet behaald</b><br />
      U blijft belegd binnen het huidige profiel, maar wij adviseren u wanneer mogelijk, uw
      looptijd te verlengen. Mogelijk in combinatie met het eenmalig of periodiek verhogen van
      uw inleg. Klik op de knop om uw klantprofiel te openen en uw looptijd aan te passen.
      Heeft u vragen of hulp nodig, klik dan op 'Contact opnemen' in het menu.
    </div>
    <button @click="$parent.redo()" class="alertButton">
      Open klantprofiel
    </button>
  </div>
</template>

<script>
import { sumBy } from 'lodash-es';

export default {
  name: 'startGoalAlerts',
  props: {
    currentPort: Object,
  },
  computed: {
    total() {
      return sumBy(this.$parent.positions, 'worth');
    },
    daysTillGoal() {
      return (
        (new Date(this.currentPort.target_date)).getTime()
        - (new Date()).getTime()
      ) / 1000 / 24 / 60 / 60;
    },
  },
};
</script>
